import type { ApexOptions } from 'apexcharts'
import { buildDonutChartOptions, type DonutChartItem } from '../shared/charts'

export interface DashboardDonutItem {
  name: string
  value: number
  diff: number
  color: string
}

export const getDashboardDonutChartOptions = (items: DashboardDonutItem[]): ApexOptions => {
  const donutItems: DonutChartItem[] = items.map((item) => ({
    name: item.name,
    value: item.value,
    color: item.color
  }))

  return buildDonutChartOptions({ items: donutItems })
}
